
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faCircleNotch, faCoins } from '@fortawesome/free-solid-svg-icons'
import Modal from 'react-modal';
import Select from "react-select";
import { useUser } from "../utils/UserContext";
import { toast } from 'react-hot-toast';
import { Link } from "react-router-dom"

function StakeCard({stake_id, coin_id, image, name, symbol, min, max, cycle, roi }) {
    const { user } = useUser();
    const [modalIsOpen1, setIsOpen1] = useState(false);
    const [disable, setDisable] = useState(true);
    const [loading1, setLoading1] = useState(false);
    const [loading2, setLoading2] = useState(false);
    const [minimum_amt, setMinimum_amt] = useState(min);
    const [maximum_amt, setMaximum_amt] = useState(max);
    const [scoin_id, setScoin_id] = useState(coin_id);
    const [scycle, setScycle] = useState(cycle);
    const [sroi, setSroi] = useState(roi);
    const [crypto, setCrypto] = useState([]);
    useEffect(() => {
      if(scoin_id && minimum_amt && maximum_amt && scycle && sroi){
        setDisable(false);
      }else{
        setDisable(true);
      }
    }, [scoin_id, minimum_amt, maximum_amt, scycle, sroi]);
    const darkThemeStyles = {
        control: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
          border: "none",
          color: "#fff",
        }),
        menu: (styles) => ({
          ...styles,
          backgroundColor: "#151719",
        }),
        option: (styles, { isFocused, isSelected }) => ({
          ...styles,
          backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
          color: "#fff",
        }),
        singleValue: (styles) => ({
          ...styles,
          color: "#fff",
        }),
    };
    useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          symbol: coin.symbol,
          value: coin.id,
          label: (
            <>
              <img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" style={{ marginRight: 5 }} />
              {coin.symbol}
            </>
          ),
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
    }, []);
    const EditStake= () =>{
      setLoading1(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/stake.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_editstake: true, coin_id : scoin_id, minimum_amt : minimum_amt, maximum_amt : maximum_amt, cycle : scycle, roi : sroi, stake_id : stake_id})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "stake";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading1(false);
      })
      .catch(err => {
        console.error(err)
        setLoading1(false);
      })
    }
    const DeleteStake = () =>{
      setLoading2(true);
      fetch(`${process.env.REACT_APP_API_URL}controller/stake.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_deletestake: true, stake_id : stake_id})
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          toast.success(data.result);
          setTimeout(() => {
            window.location.href = "stake";
          }, 2000);
        }else{
          toast.error(data.message);
        }
        setLoading2(false);
      })
      .catch(err => {
        console.error(err)
        setLoading2(false);
      })
    }

    return (

      <div className="mycard position-relative overflow-hidden" style={{border:'1px solid #e8e8e812'}}>
        <img src={require(`../images/background-icon2.png`)} alt="chart" className="position-absolute" style={{height:'200px', right:'-15%', top:'0%', zIndex:'1'}}/>
        <div className="d-flex align-items-center justify-content-between mb-2">
          <div className="d-flex align-items-center">
            {image}
            <div className="ms-2">
              <p className="mb-0 fw-bold" style={{fontSize:'20px'}}>{name}</p>
              <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Interest</p>
            </div>
          </div>
          <div className="ms-2 text-end">
            <p className="mb-0 text-secondary">APY</p>
            <p className="mb-0" style={{fontSize:'14px'}}>{roi}%</p>
          </div>
        </div>
        <div className="d-flex align-items-start justify-content-between">
          <div>
            <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{max} {symbol}</p>
            <p className="mb-2 text-secondary" style={{fontSize:'14px'}}>Maximum Stake</p>
            <p className="mb-0 fw-bold" style={{fontSize:'18px'}}>{cycle}</p>
            <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Investment Cycle</p>
          </div>
          {user?.user_type === "adminface" && (
            <p className="mb-5 text-prime fw-semibold" onClick={() => setIsOpen1(true)} style={{cursor: 'pointer'}}>Edit</p>
          )}
        </div>
        <div className="d-flex align-items-start justify-content-between mt-4">
          <div>
            <p className="text-secondary mb-0">Min Stake</p>
            <p className="mb-0 fw-bold" style={{fontSize:'16px'}}>{min} {symbol}</p>
          </div>
          <Link to="/stakedetails" state={{stake_id: stake_id}} className="myBtn bg-prime rounded-pill text-center" style={{paddingTop: '12px',paddingBottom: '12px'}}>
            <FontAwesomeIcon icon={faCoins} className="me-1" style={{fontSize: '14px'}} /> Stake Now
          </Link>
        </div>
        <Modal
            isOpen={modalIsOpen1}
            onRequestClose={() => setIsOpen1(false)}
            shouldCloseOnOverlayClick={true} 
            closeTimeoutMS={100}
            className="shortmode"
        >
            <div className="d-flex align-items-center justify-content-between">
                <p className="mb-0 fw-bold text-white" style={{fontSize: '16px'}}>
                Add staking pool</p>
                <FontAwesomeIcon className="py-1 px-2 rounded-3" icon={faXmark} style={{fontSize: '15px', backgroundColor: 'rgba(255, 255, 255, 0.1)', cursor: 'pointer'}} onClick={() => setIsOpen1(false)} />
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Assets:</label>
            <Select 
                options={crypto} 
                value={crypto.find((opt) => opt.value === scoin_id)}
                onChange={(selected) => {
                    setScoin_id(selected.value); 
                }}
                isSearchable
                styles={darkThemeStyles}
                className="w-full"
            />
            <div className="row">
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Minimum:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={minimum_amt}
                      onChange={(e) => setMinimum_amt(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    {(() => {
                        const selectedCoin = crypto.find(opt => opt.value === coin_id);
                        return selectedCoin && (
                          <>
                            <img src={selectedCoin.logo} alt={selectedCoin.symbol} width="20" style={{ marginRight: 5 }} />
                            {selectedCoin.symbol}
                          </>
                        );
                      })()}
                    </div>
                </div>
              </div>
              <div className="col-6">
                <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>Maximum:</label>
                <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                    <input 
                      type="number"
                      placeholder="1000"
                      className="inputNone"
                      value={maximum_amt}
                      onChange={(e) => setMaximum_amt(e.target.value)}
                    />
                    <div
                      className="fw-bold text-white d-flex align-items-center"
                      style={{
                        backgroundColor: 'rgb(30, 33, 36)',
                        borderRadius: '4px',
                        padding: '6px',
                        fontSize: '14px',
                        cursor: 'pointer' 
                      }}
                    >
                    {(() => {
                        const selectedCoin = crypto.find(opt => opt.value === coin_id);
                        return selectedCoin && (
                          <>
                            <img src={selectedCoin.logo} alt={selectedCoin.symbol} width="20" style={{ marginRight: 5 }} />
                            {selectedCoin.symbol}
                          </>
                        );
                      })()}
                    </div>
                </div>
              </div>
            </div>
            <label className="fw-semibold mb-1 mt-2" style={{fontSize: '14px'}}>Cycle:</label>
            <div className="form-control py-2">
                <input 
                  type="text"
                  placeholder="Daily"
                  className="inputNone"
                  value={scycle}
                  onChange={(e) => setScycle(e.target.value)}
                />
            </div>
            <label className="fw-semibold mt-2 mb-1" style={{fontSize: '14px'}}>ROI:</label>
            <div className={`d-flex align-items-between form-control justify-content-between py-1 pe-1 `}>
                <input 
                  type="number"
                  placeholder="2"
                  className="inputNone"
                  value={sroi}
                  onChange={(e) => setSroi(e.target.value)}
                />
                <div
                  className="fw-bold text-white d-flex align-items-center"
                  style={{
                    backgroundColor: 'rgb(30, 33, 36)',
                    borderRadius: '4px',
                    padding: '6px',
                    fontSize: '14px',
                    cursor: 'pointer' 
                  }}
                >
                  %
                </div>
            </div>
            <div className="d-flex align-items- justify-content-between" style={{gap: '10px'}}>
              <div className={`myBtn w-100 text-center mt-3 bg-danger`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={DeleteStake}>{loading2?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Delete'}</div>
              <div className={`myBtn w-100 text-center mt-3 bg-prime ${disable?'disabled':null}`} style={{paddingTop: '12px',paddingBottom: '12px'}} onClick={!disable ? EditStake : null}>{loading1?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Save'}</div>
            </div>
          </Modal>
      </div>
    )
  }
  
  export default StakeCard